import { type MyMultiFactorStatusFragment, useGetMyMultiFactorStatusQuery } from "~/gql/queries/multiFactor.generated";

export interface UseMultiFactorStatusReturn {
	isError: boolean;
	isLoading: boolean;
	refetch: () => void;
	status: MyMultiFactorStatusFragment | null;
}

export interface UseMultiFactorStatusParams {
	skip?: boolean;
}

const useMultiFactorStatus = ({ skip = false }: UseMultiFactorStatusParams = {}): UseMultiFactorStatusReturn => {
	const { data, isError, isLoading, refetch } = useGetMyMultiFactorStatusQuery(undefined, { skip });

	return {
		isError: isError || !!data?.myMultiFactorStatus?.errors?.length,
		isLoading,
		refetch,
		status: data?.myMultiFactorStatus?.status ?? null
	};
};

export default useMultiFactorStatus;
